import React from "react";

const ContactUs = () => {
  return (
    <div style={{ fontFamily: "'Poppins', sans-serif" }}>
      {/* Banner */}
      <div
        style={{
          backgroundImage: "url('https://i.ibb.co/1fSyDjVZ/background-page-title.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          padding: "60px 0",
          textAlign: "center",
          color: "#000"
        }}
      >
        <h1 style={{ fontSize: "40px", marginBottom: "10px" }}>Contact Us</h1>
        <p style={{ fontSize: "16px" }}>
          <a href="/" style={{ color: "#000", textDecoration: "none" }}>Home</a> / Contact Us
        </p>
      </div>

      {/* Contact Info Section */}
      <div style={{ padding: "40px 20px", maxWidth: "1200px", margin: "0 auto" }}>
        <div style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between"
        }}>
          {/* Address */}
          <div style={{
            flex: "1 1 30%",
            padding: "20px",
            backgroundColor: "#f8f8f8",
            borderRadius: "10px",
            marginBottom: "20px",
            textAlign: "center"
          }}>
            <img src="https://cdn-icons-png.flaticon.com/512/684/684908.png" alt="Address" style={{ width: "50px", marginBottom: "10px" }} />
            <h3>Our Address</h3>
            <p>123 Street, City, State, India</p>
          </div>

          {/* Email */}
          <div style={{
            flex: "1 1 30%",
            padding: "20px",
            backgroundColor: "#f8f8f8",
            borderRadius: "10px",
            marginBottom: "20px",
            textAlign: "center"
          }}>
            <img src="https://cdn-icons-png.flaticon.com/512/561/561127.png" alt="Email" style={{ width: "50px", marginBottom: "10px" }} />
            <h3>Email Us</h3>
            <p>contact@support@healthplus.com</p>
          </div>

          {/* Phone */}
          <div style={{
            flex: "1 1 30%",
            padding: "20px",
            backgroundColor: "#f8f8f8",
            borderRadius: "10px",
            marginBottom: "20px",
            textAlign: "center"
          }}>
            <img src="https://cdn-icons-png.flaticon.com/512/483/483947.png" alt="Phone" style={{ width: "50px", marginBottom: "10px" }} />
            <h3>Call Us</h3>
            <p>+91 98765 43210</p>
          </div>
        </div>
      </div>

      {/* Google Map Embed */}
      <div style={{ padding: "0 20px 40px" }}>
        <iframe
          title="Google Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.0931738476634!2d144.95565151532065!3d-37.81725497975178!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad65d50526ce2f5%3A0x94c0e7fefb8c2516!2sFederation%20Square!5e0!3m2!1sen!2sin!4v1600000000000!5m2!1sen!2sin"
          width="100%"
          height="400"
          frameBorder="0"
          style={{ border: 0, borderRadius: "10px" }}
          allowFullScreen=""
          aria-hidden="false"
          tabIndex="0"
        ></iframe>
      </div>
    </div>
  );
};

export default ContactUs;
